import { createFormItem } from "@/component-create/utils/create-form-item"
import { SearchForm } from "@/component-create/SearchForm"
import { FORM_ITEM } from "@/components/form/enums"

export function searchForm(el: Element) {
  const searchForm = new SearchForm(el, items, { labelWidth: '80px' })
  return searchForm
}

const items = [
  createFormItem('角色名称', 'roleName', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  createFormItem('角色代码', 'nickname', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
]